import ViewBase from '../../view-base.view';
import aiJpoModel from '../../../models/schedule/ai-jpo.model';
import languageModel from '../../../models/language.model';
import { Dialog } from 'construct-ui';

export default function SchedulePopupDialog() {
    ViewBase.call(this);

    let schedules = [];
    let group = {};
    let isOpen = false;

    let loadSchedules = () => {
        aiJpoModel.getSummarySchedulesPopup({
            groupId: group.groupID,
            month: group.month
        })
            .then((result) => {
                schedules = result || [];
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    return {
        oninit: ({ attrs }) => {
            isOpen = attrs.isOpen;
            group = attrs.group || {};
            if (isOpen) loadSchedules();
        },
        onupdate: ({ attrs }) => {
            if (attrs.isOpen !== isOpen) {
                isOpen = attrs.isOpen;
                if (isOpen) {
                    group = attrs.group || {};
                    loadSchedules();
                }
            }
        },
        view: ({ attrs }) => {
            if (!isOpen) return null;

            const title = (group.groupName || '') + ' — ' + languageModel.getText('', 'Visit Schedule');

            return m(Dialog, {
                class: 'cui-dialog-xl',
                isOpen: isOpen,
                onClose: attrs.onClose,
                title: title,
                content: [
                    m('.table-responsive',
                        m('table.table.table-bordered',
                            m('thead.thead-bggrey',
                                m('tr.align-middle', [
                                    m('th', { scope: 'col' }, languageModel.getText('', 'Schedule Date')),
                                    m('th', { scope: 'col' }, languageModel.getText('', 'Supervisor')),
                                    m('th', { scope: 'col' }, languageModel.getText('', 'Store Code')),
                                    m('th', { scope: 'col', style: 'width: 80px;' }, languageModel.getText('', 'Grade')),
                                    m('th', { scope: 'col', style: 'width: 100px;' }, languageModel.getText('', 'Start Time')),
                                    m('th', { scope: 'col', style: 'width: 100px;' }, languageModel.getText('', 'End Time')),
                                    m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Travel (min)')),
                                    m('th', { scope: 'col', style: 'width: 90px;' }, languageModel.getText('', 'Dwell (min)')),
                                ])
                            ),
                            m('tbody',
                                schedules.length === 0 &&
                                    m('tr.align-middle',
                                        m('td', { colspan: '8' }, languageModel.getText('', 'No records found.'))
                                    ),
                                schedules.map((r) =>
                                    m('tr', [
                                        m('td', r.scheduleDate || ''),
                                        m('td', r.supervisor || ''),
                                        m('td', r.storeCode || ''),
                                        m('td.text-center',
                                            m('span.ai-jpo-grade.ai-jpo-grade-' + (r.grade || '').toLowerCase(), r.grade || '')
                                        ),
                                        m('td', r.startTime || ''),
                                        m('td', r.endTime || ''),
                                        m('td.text-end', r.travelMinutes ?? ''),
                                        m('td.text-end', r.dwellMinutes ?? ''),
                                    ])
                                )
                            )
                        )
                    )
                ]
            });
        }
    };
}
